<template>
  <div class="lecture-info">
    <standard-header left-div="blank" title="Textbook Progress" />

    <!-- 전체강의 일정 List  -->
    <div class="course-date-section" @click="isDisplayPopup = true">
      <div class="course-weekly">{{ weekTitle.title1 }}</div>
      <div class="date">{{ weekTitle.title2 }}</div>
      <div class="button">
        <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/common/down-arrow-primary.png" width="20" height="20" >
      </div>
    </div>


    <!-- 수강현황 -->
    <div class="totle-course">
      <div class="title">
        <span>full lecture</span>
        <div class="icon"><ion-toggle mode="ios" :checked="isAllStudy" @ionChange="changeStudyStatus"></ion-toggle></div>
        <span>remaining lectures</span>
      </div>
      <table class="table" border="1">
        <tr class="course-name">
          <td class="course0" :class="{active : activeColumn === '1'}" @click="courseShowEvent('1')">*</td>
          <td class="course1" :class="{active : activeColumn === '2'}" @click="courseShowEvent('2')">{{ courseName[0] }}</td>
          <td class="course2" :class="{active : activeColumn === '3'}" @click="courseShowEvent('3')">{{ courseName[1] }}</td>
          <td class="course3" :class="{active : activeColumn === '4'}" @click="courseShowEvent('4')">{{ courseName[2] }}</td>
          <td class="course4" :class="{active : activeColumn === '5'}" @click="courseShowEvent('5')">{{ courseName[3] }}</td>
          <td class="course5" :class="{active : activeColumn === '6'}" @click="courseShowEvent('6')">{{ courseName[4] }}</td>
          <td class="course6" :class="{active : activeColumn === '7'}" @click="courseShowEvent('7')">{{ courseName[5] }}</td>
        </tr>
        <tr class="course-number">
          <td :class="{active : activeColumn === '1'}" @click="courseShowEvent('1')">{{ summaryStudy }}</td>
          <td :class="{active : activeColumn === '2'}" @click="courseShowEvent('2')">{{ courseNumber[0] }}</td>
          <td :class="{active : activeColumn === '3'}" @click="courseShowEvent('3')">{{ courseNumber[1] }}</td>
          <td :class="{active : activeColumn === '4'}" @click="courseShowEvent('4')">{{ courseNumber[2] }}</td>
          <td :class="{active : activeColumn === '5'}" @click="courseShowEvent('5')">{{ courseNumber[3] }}</td>
          <td :class="{active : activeColumn === '6'}" @click="courseShowEvent('6')">{{ courseNumber[4] }}</td>
          <td :class="{active : activeColumn === '7'}" @click="courseShowEvent('7')">{{ courseNumber[5] }}</td>
        </tr>
      </table>
    </div>

    <div v-if="!isMobileApp">
      <div class="player-div" v-show="isShowPlayer">
        <div class="player-basic">
          <vue-plyr :options="playerOptions" ref="plyr2" id="player2"
                    @timeupdate="videoTimeUpdated" @playing="nowPlaying" @ready="playerReady" @pause="updatePaused"
                    :emit="['ready','timeupdate','playing']">
            <audio :src="courseinfo.audio_url" format="audio/mp3" @ended="playEnd"></audio>
          </vue-plyr>

          <div class="button-group">
            <div class="repeat">
              <img v-if="!playerInfo.isRepeat" src="/assets/player/repeat.png" width="17" height="20" @click="repeatClickEvent" />
              <img v-if="playerInfo.isRepeat" src="/assets/player/repeat-active.png" width="17" height="20" @click="repeatClickEvent" />
            </div>
            <div class="backward">
              <img src="/assets/player/backward.png" width="30" height="16" @click="backwardClickEvent" />
            </div>
            <div v-if="!playerInfo.isPlaying" class="play" @click="playClickEvent">
              <img src="/assets/player/play.png" height="33" />
            </div>
            <div v-else class="pause" @click="playClickEvent">
              <img src="/assets/player/pause.png" height="33" />
            </div>
            <div class="forward">
              <img src="/assets/player/forward.png" width="30" height="16" @click="forkwardClickEvent"/>
            </div>
            <div class="speed" @click="changeSpeed">
              <img v-if="playerInfo.speed === 0.5" src="/assets/player/0.5x.png" width="18" height="20" />
              <img v-if="playerInfo.speed === 1" src="/assets/player/1x.png" width="18" height="20" />
              <img v-if="playerInfo.speed === 1.5" src="/assets/player/1.5x.png" width="18" height="20" />
              <img v-if="playerInfo.speed === 2" src="/assets/player/2x.png" width="18" height="20" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-section-line-1px"></div>

    <!-- 강의 List -->
    <div class="lecture-list-section">
      <div class="list-title">
        <div class="date-information">
          <div class="date-number" >{{ todayInfo.dateNumber }}</div>
          <div class="date-day">({{ todayInfo.dateDay }})</div>
        </div>
        <div class="total-lecture">
          <div class="title">All <span v-html="courseFilterList.length">0</span>Lecture</div>
          <div class="button" v-if="courseList.length !== 0">
            <img src="/assets/preview/play.png" width="17" height="18" @click="playAllCourse()" />
          </div>
        </div>
      </div>
      <ul class="lecture-list">
        <li v-for="(course, i) in courseFilterList" :key="i">
          <div class="lecture-title">
            <div class="word_comma_1" v-bind:class="{active : course.course_no == courseinfo.course_no}" @click="initPlayLecture(course.course_no, false)">{{ course.course_name }}</div>
            <div class="keyword-info" v-bind:class="{active : course.course_no == courseinfo.course_no}" @click="initPlayLecture(course.course_no, false)">{{ course.keyword }}</div>
            <div class="lecture-view">
              <div class="time"><img src="/assets/preview/clock-gray.png" width="11" height="11" />{{ course.course_time }}</div>
              <div class="count">
                <img src="/assets/preview/view-gray.png" width="12" height="8" />{{ course.view_count }}</div>
            </div>
          </div>
          <div class="play-button" @click="initPlayLecture(course.course_no, false)">
            <img src="/assets/preview/play-color.png" width="15" height="16" />
          </div>
          <div class="menu-button" @click="presentActionSheet(course.course_no)"><img src="/assets/preview/menu.png" width="3" height="12" /></div>
        </li>
      </ul>
    </div>

    <div class="list-section-line-1px"></div>

    <footer-toolbar />

    <course-schedule v-if="isDisplayPopup" @showDisplay="displayPopup" @updateWeekInfo="updateWeekInfo"/>

    <!-- 플레이리스트 선택 ion-select (화면에는 숨김)-->
    <ion-select class="play-list-select" v-show="false" mode="ios" interface="action-sheet" cancel-text="취소" @ionChange="putPlayList($event.target.value)">
      <ion-select-option v-bind:value="0">플레이리스트에 담기</ion-select-option>
      <ion-select-option v-bind:value="list.playlist_no" v-for="(list, index) in myPlayList" :key="index">{{ list.title }}</ion-select-option>
    </ion-select>

  </div>
</template>

<script>
import * as biz from '../../utils/biz';
import * as ajax from '../../utils/ajax';
import * as alert from '../../utils/alert';
import * as utils from "../../utils/utils";
import StandardHeader from "../../components/header/StandardHeader";
import FooterToolbar from "../../components/footer/FooterToolbar";
import CourseSchedule from "../../components/popup/CourseSchedule";
import Vue from "vue";
export const EventBus = new Vue();

const BACKWARD_SECOND_TIME = 30;
const FORWARD_SECOND_TIME = 30;

export default {
  name: 'Course',
  components: {StandardHeader, FooterToolbar, CourseSchedule},
  data() {
    return {
      isDisplayPopup: false,
      isLogin: false,
      isAllStudy: false,
      activeColumn: '1',
      courseName: [],
      courseNumber: [1, 2, 3, 4, 5, 6],
      weekTitle: {
        title1: "",
        title2: ""
      },
      courseList: [
        {
          course_name:"1Lecture Programming",
          course_time:"5:00",
          view_count:10
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }, {
          course_name:"aaaaa",
          course_time:"4353245",
          view_count:324
        }
      ],
      courseFilterList: [],
      todayInfo: {
        dateNumber: "31",
        dateDay: "Fri"
      },
      playerInfo: {
        mode: "mini",
        isPlaying: false,
        isRepeat: false,
        speed: 1,
        is70: false             // 70% 여부
      },
      courseinfo: {
        course_no: null,
        audio_url: null
      },
      isShowPlayer: false,
      isAllPlay: false,
      isCourseCount: 0,
      play_course_no: null,
      currentWeek: {},
      myPlayList: [],
      isMobileApp: false,
      isRole:false,
      isShowGuide:false
    }
  },
  created() {
    this.isLogin = biz.isLogin(this);

    EventBus.$on("updateStudyCnt", this.updateStudyCnt);
  },
  mounted() {
    this.getTodayInfo();
    this.getTodayWeek();
    // UserAgent에 'mobileApp' 이 이는지 확인해서 플래그를 만듬...
    this.isMobileApp = /(mobileApp)/i.test(window.navigator.userAgent);
  },
  methods: {
    getTodayInfo() {
      const today = new Date();
      let day;

      switch (today.getDay()) {
        case 0:
          day = "Sun";
          break;
        case 1:
          day = "Mon";
          break;
        case 2:
          day = "Tue";
          break;
        case 3:
          day = "Wed";
          break;
        case 4:
          day = "Thr";
          break;
        case 5:
          day = "Fri";
          break;
        case 6:
          day = "Sat";
          break;
      }
      this.todayInfo.dateNumber = today.getDate();
      this.todayInfo.dateDay = day;
    },
    getTodayWeek() {
      ajax.Get(this, "/api/member/schedule/week", function(ref, data) {
        const item = data.filter(item => item.is_today === "1");
        ref.updateWeekInfo(item[0], false);
      });
    },
    updateStudyCnt() {
      this.updateWeekInfo(this.currentWeek, true);
    },
    courseShowEvent(div) {
      this.activeColumn = div;
      const subjectName = this.courseName[Number(div) - 2];
      let subjectCode;

      switch (subjectName) {
        case "국":
          subjectCode = "10";
          break;
        case "영":
          subjectCode = "11";
          break;
        case "수":
          subjectCode = "12";
          break;
        case "사":
          subjectCode = "13";
          break;
        case "과":
          subjectCode = "14";
          break;
        case "방":
          subjectCode = "15";
          break;
        case "역":
          subjectCode = "16";
          break;
        case "바":
          subjectCode = "17";
          break;
      }

      if (div === "1") {
        this.updateCourseFilterList("");

      } else {
        this.updateCourseFilterList(subjectCode);
      }
    },
    displayPopup(isDisplayPopup) {
      this.isDisplayPopup = isDisplayPopup;
    },
    playAllCourse() {
      if (this.courseFilterList.length !== 0) {
        this.initPlayLecture(this.courseFilterList[0].course_no, true);
        //biz.playAudioPlayer(this.courseList[0].course_no);
      }
    },
    initPlayLecture(courseNo, isAllPlay) {
      ajax.Get(this, "/api/contents/course/play/role/" + courseNo, function(ref, data) {

        if (data === "success")
          ref.isRole = true;
        else
          ref.isRole = false;
        ref.playLecture(courseNo, isAllPlay);
      });

    },
    playLecture(courseNo, isAllPlay) {
      const app = EventBus;

      EventBus.$emit('checkRoleCheck', courseNo);
      // ajax.Get(app, "/api/contents/course/play/role/" + courseNo, function(ref, data) {
      //   if (data === "success")
      //     EventBus.$emit('initcourseinfo', courseNo);
      // });

      if (!this.isMobileApp) {
        // EventBus.$emit('stopMiniPlayer');
        biz.stopAudioPlayer();

        this.updatePlaytime();
      }

      this.isAllPlay = isAllPlay;
      this.isShowPlayer = true;

      for (let item in this.courseFilterList) {
        if (this.courseFilterList[item].course_no === courseNo) {
          this.isCourseCount = Number(item);
        }
      }

      // 강의정보
      ajax.Get(this, "/api/contents/course/" + courseNo, function(ref, data) {
        ref.courseinfo.course_no = data.course_no;
        ref.courseinfo.audio_url = data.audio_url;

        if (!ref.isMobileApp) {
          // 데이터를 불러오는 시간차 때문에 바로 재생이 않되여 타임슬림을 1초정도
          // TODO Event 로 해결
          setTimeout(function() { ref.playClickEvent() }, 1000);
        }
        else {
          var accessToken = ref.$cookie.get("accessToken");
          if (accessToken == null)
            accessToken = "";
          ref.courseinfo.accessToken = accessToken;
          ref.courseinfo.course_name = data.course_name;
          ref.courseinfo.course_no = data.course_no;
          ref.courseinfo.school_grade_name = data.school_grade_name;
          ref.courseinfo.thumb_url = data.thumb_url;
          ref.courseinfo.subject_name = data.subject_name;

          const params = {
            courseinfo: ref.courseinfo,
            scheduleCourseList: ref.courseFilterList,
            isCourseCount: ref.isCourseCount,
            isAllPlay:ref.isAllPlay
          };

          switch(utils.deviceInfo()) {
            case "Android":
              window.listenApp.playLecture(JSON.stringify(params));
              break;
            case "iOS":
              window.webkit.messageHandlers.playLecture.postMessage(params);
              break;
          }
        }
      });

      if (!this.isMobileApp) {
        // 조회 수 추가
        ajax.Put(this, "/api/contents/course/view/" + courseNo, null, null);

        if (biz.isLogin(this)) {
          // 내가 본 강의 추가
          ajax.Post(this, "/api/member/member/listen", {course_no: courseNo}, null);

          // 수강내역 추가
          const params = {
            course_no: courseNo,
            listen_div: "10"
          };
          ajax.Post(this, "/api/member/member/study", params, null);
        }
      }

      this.playerInfo.is70 = false;

      //biz.playScheduleAudioPlayer(courseNo, this.courseList);
    },
    // 플레이리스트 열기
    playListCourse(course_no) {
      if (!biz.isLogin(this)) {
        alert.alertLogin(this);
        return;
      }

      console.log("Course.playListCourse");
      this.play_course_no = course_no;
      this.getMyPlayList();
      const select = document.querySelector('.lecture-info .play-list-select');

      setTimeout(function() {
        console.log("Course.showList");
        select.value = '';
        select.click();
      }, 200);
    },
    // my playlist 가져오기
    getMyPlayList() {
      const params = {};
      ajax.Post(this, "/api/member/playlist/search", params, function(ref, data) {
        ref.myPlayList = data;
        console.log("Course.getMyPlayList="+JSON.stringify(data));
      });
    },
    // 플레이리스트 추가
    addPlayList() {
      alert.alertPrompt(this, "Add new playlist", "Input your name, please.", function(ref, data) {
        const params = {
          title: data["0"]
        };
        ajax.Post(ref, "/api/member/playlist/", params, function(ref, data) {
           alert.alert("새 플레이리스트가 등록 되었습니다.", "확인");
          ref.playListCourse();
        });
      });
    },
    // 플레이리스트 담기
    putPlayList(playlist_no) {
      if (playlist_no === "0") {
        this.addPlayList();
      } else if (playlist_no !== "" && playlist_no !== null) {
        const params = {
          course_no: this.play_course_no,
          playlist_no: playlist_no
        };
        ajax.Post(this, "/api/member/playlist/detail", params, function (ref, data) {
          ref.isActive = data.my_count > 0;

          if (ref.isActive) {
            alert.alert("Added lecture.", "확인");
          } else {
            alert.alert("Added lectures deleted.", "확인");
          }
        });
      }
    },
    limit2minuteGuide() {
      if (this.isShowGuide)
        return;
      this.isShowGuide = true;
      document.querySelector('ion-alert-controller').create({
         message:
            "<b>2분 미리듣기가 완료되었습니다.</b>\n\n앗! 정회원이 아니시군요 ㅠㅠ\n<b>이 강의는 정회원만 이용할 수 있어요.</b>\n지금 바로 이용권을 구매하고\n초중등 전학년 전과목 모든 콘텐츠를 무제한\n이용할 수 있는 <b>정회원만의 특별한 혜택</b>을 누려보세요!",
          buttons: [
            {
              text: "다음번에 할래요",
              role: "cancel",
              cssClass: "secondary",
              handler: () => {
                // console.log('Confirm Cancel');
              this.isShowGuide = false;
              },
            },
            {
              text: "이용권 종류 보러가기",
              handler: () => {
              this.isShowGuide = false;
                window.location = "/mypage/ticket";
              },
            },
          ],
          mode: "ios",
      }).then(alert => {
        alert.present();
      });
    },
    putCourse(course_no) {
      const params = {
        interest_div: "20",
        relation_no: course_no
      };
      ajax.Post(this, "/api/board/interest/", params, function(ref, data) {
        ref.isActive = data.my_count > 0;

        if (ref.isActive) {
          alert.alert("Included lectures.", "확인");
        } else {
          alert.alert("Included lecture has been deleted.", "확인");
        }
      });
    },
    presentActionSheet(course_no) {
      if (!this.isLogin) {
        alert.alertLogin(this);
        return;
      }
      return this.$ionic.actionSheetController
          .create({
            mode: "ios",
            buttons: [
              {
                text: 'Add Lecture',
                handler: () => {
                  this.putCourse(course_no);
                },
              },
              /*{
                  text: '다운로드',
                  handler: () => {
                      this.downloadCourse(course_no);
                  },
              },*/
              {
                text: 'Playlist',
                handler: () => {
                  this.playListCourse(course_no);
                },
              },
              {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                },
              }
            ]
          }).then(a => a.present())
    },
    updateWeekInfo(item, isPlayEnd) {
      this.isDisplayPopup = false;
      this.currentWeek = item;

      // refresh title
      const title1 = item.month + "Month" + item.week + "Week Lecture";
      const title2 = "(" + item.begin_date + " ~ " + item.finish_date + ")";

      this.weekTitle.title1 = title1;
      this.weekTitle.title2 = title2;


      const params = {
        week: item.all_week
      };
      ajax.Post(this, "/api/member/schedule/course", params, function(ref, data) {
        ref.courseList = data;

        for (let key in data) {
          if (data[key].keyword != null) {
            const keywords = data[key].keyword.split(",");
            data[key].keyword = "";
            for (let index in keywords) {
              data[key].keyword += "#"+keywords[index].replace(/\s/g,"") + " ";
            }
          }
        }

        ref.updateStudyCount();

        if (isPlayEnd) {
          ref.courseShowEvent(ref.activeColumn);
        } else {
          ref.updateCourseFilterList();
          ref.activeColumn = "1";
        }
      });
    },
    changeStudyStatus() {
      this.isAllStudy = !this.isAllStudy;
      this.updateStudyCount();
      this.updateCourseFilterList();
      this.courseShowEvent(0);
    },
    updateStudyCount() {
      let subject10 = 0;
      let subject11 = 0;
      let subject12 = 0;
      let subject13 = 0;
      let subject14 = 0;
      let subject15 = 0;
      let subject16 = 0;
      let subject17 = 0;

      for (let item of this.courseList) {
        switch (item.subject) {
          case "10":       // 국어
            subject10 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "11":       // 영어
            subject11 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "12":       // 수학
            subject12 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "13":       // 사회
            subject13 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "14":       // 과학
            subject14 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "15":       // 봄~겨울
            subject15 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "16":       // 역사
            subject16 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
          case "17":       // 바슬즐
            subject17 += !this.isAllStudy ? 1 : (item.isStudy === 0 ? 1 : 0);
            break;
        }
      }

      // 10: 초등, 20: 중등
      const schoolDiv = this.$cookie.get("schoolDiv");
      const schoolGrade = this.$cookie.get("schoolGrade");

      switch(schoolDiv) {
        case "10":
          switch(schoolGrade) {
            case "01":
            case "02":
              this.courseName = ["국", "영", "수", "방", "바", ""];
              this.courseNumber = [subject10, subject11, subject12, subject15, subject17, ""];
              break;
            case "03":
            case "04":
            case "05":
            case "06":
              this.courseName = ["국", "영", "수", "사", "과", ""];
              this.courseNumber = [subject10, subject11, subject12, subject13, subject14, ""];
              break;
          }
          break;

        case "20":
          switch(schoolGrade) {
            case "01":
            case "02":
            case "03":
              this.courseName = ["국", "영", "수", "사", "과", "역"];
              this.courseNumber = [subject10, subject11, subject12, subject13, subject14, subject16];
              break;
          }
          break;
      }
    },
    updateCourseFilterList(subject) {
      this.courseFilterList = [];

      if (!this.isAllStudy) {
        if (subject === undefined || subject === "") {
          this.courseFilterList = this.courseList;

        } else {
          for (let item of this.courseList) {
            if (item.subject === subject) {
              this.courseFilterList.push(item);
            }
          }
        }

      } else {
        if (subject === undefined || subject === "") {
          for (let item of this.courseList) {
            if (item.isStudy === 0) {
              this.courseFilterList.push(item);
            }
          }

        } else {
          for (let item of this.courseList) {
            if (item.subject === subject && item.isStudy === 0) {
              this.courseFilterList.push(item);
            }
          }
        }
      }
    },
    videoTimeUpdated(event) {
      if (this.playerInfo.is70)
        return;

      const player = this.player();
      const currentTime = player.currentTime;
      const duration = player.duration;


      // 듣기권한이 없는 경우 2분이 되면 playstop시키고 이용권 구매 안내 팝업
      // if (currentTime > 120 && this.isRole == false) {
      if (currentTime > 12000 && this.isRole == false) {
        player.pause();
        this.playerInfo.isPlaying = false;
        this.limit2minuteGuide();
      }

      // 70% 이상 청쥐하면 완강으로 처리
      if (currentTime / duration * 100 > 70) {
        this.playerInfo.is70 = true;

        const params = {
          course_no: this.courseinfo.course_no,
          listen_div: "20"
        };
        ajax.Put(this, "/api/member/member/study", params, null);
      }

    },
    nowPlaying(event) {
      // console.log('nowPlaying :' + event);
    },
    playerReady () {
      //this.player.currentTime = 95
      // console.log('player ready')
    },
    updatePaused(event) {
      // console.log('updatePaused :' + event)
    },
    playEnd(evnet) {
      this.updateWeekInfo(this.currentWeek, true);
      //this.courseShowEvent(this.activeColumn);

      // 반복버튼이 활성화되여 있으면
      if (this.playerInfo.isRepeat) {
        return;
      }

      if (this.isAllPlay) {
        let nextCourseNo = false;
        const isCourseCount = this.isCourseCount + 1;

        if(this.courseFilterList[isCourseCount] !== undefined) {
          this.isCourseCount = isCourseCount;
          nextCourseNo = this.courseFilterList[isCourseCount].course_no;
          this.initPlayLecture(nextCourseNo, true)
        }
      } else {
        this.playerInfo.isPlaying = false;
      }
    },
    repeatClickEvent() {
      this.playerInfo.isRepeat = !this.playerInfo.isRepeat;

      const player = this.player();
      player.loop = this.playerInfo.isRepeat;
    },
    // 뒤로 30초
    backwardClickEvent() {
      this.player().rewind(BACKWARD_SECOND_TIME);
    },
    playClickEvent() {
      if (this.isPlaying()) {
        this.player().pause();
        this.playerInfo.isPlaying = false;

      } else {
        this.player().play();
        this.player().speed = this.playerInfo.speed;
        this.playerInfo.isPlaying = true;
      }
    },
    // 앞으로 30초
    forkwardClickEvent() {
      this.player().forward(FORWARD_SECOND_TIME);
    },
    changeSpeed() {
      switch (this.playerInfo.speed) {
        case 0.5:
          this.playerInfo.speed = 1;
          break;
        case 1:
          this.playerInfo.speed = 1.5;
          break;
        case 1.5:
          this.playerInfo.speed = 2;
          break;
        case 2:
          this.playerInfo.speed = 0.5;
          break;
      }

      const player = this.player();
      player.speed = this.playerInfo.speed;
    },
    updatePlaytime() {
      if (this.courseinfo.course_no === 0)
        return;


      const player = this.player();
      const currentTime = player.currentTime;

      const params = {
        course_no: this.courseinfo.course_no,
        summary_second: currentTime
      };
      ajax.Post(this, "/api/contents/course/time/summary", params, null);
    },
    player() {
      return this.$refs.plyr2.player;
    },
    isPlaying() {
      const player = this.player();
      return player.playing;
    }
  },
  filters: {
    convertSchoolGrade(value) {
      return utils.convertSchoolGrade(value);
    }
  },
  computed: {
    summaryStudy() {
      return this.courseNumber[0] + this.courseNumber[1] + this.courseNumber[2] +
          this.courseNumber[3] + this.courseNumber[4] + this.courseNumber[5];
    },
    playerOptions() {
      const options = {
        controls: ['progress','current-time','duration'],
        storage: { enabled: true, key: 'plyr' }
        //autoplay: true
      };
      return options
    }
  }
}
</script>
<style scoped lang="scss">
div.lecture-info {
  overflow-y: auto;

  div.course-date-section {
    background-color: #ff6b00;
    font-weight: 500;

    div.course-weekly {
      color: #fff;
      text-align: center ;
      margin: auto;
      padding-top: 7px;
    }

    div.date {
      font-size: 12px;
      text-align: center;
      margin: auto;
      padding-bottom: 7px;
    }

    div.button {
      position: absolute;
      top: 73px;
      right: 10px;
    }

  }

  /** 수강 현황 **/
  div.totle-course {
    background-color: #f1f1f1;
    padding: 20px 12px 30px;
    font-weight: 400;

    div.title {
      display: flex;
      justify-content: center;
      margin-bottom: 14px;

      div.icon {
        padding: 0 14px;
      }
    }
    table.table {
      border: 1px solid #f1f1f1;
      text-align: center;
      width: 100%;
      height: 80px;
      box-shadow: 0 4px #d4d4d4;
      table-layout: fixed;

      // div.table.active {
      // font-weight: $font-weight700;
      // color: $primary-color;
      // }

      tr.course-name {
        background: black;
        color: #fff;
      }

      tr.course-number {
        background-color: #fff;
        height: 40px;
      }

      tr td.active {
        color: $primary-color;
        font-weight: 500;
      }
    }
  }

  /** 강의 List **/
  div.lecture-list-section {
    padding: 17px 24px;
    background-color: #fff;

    div.list-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      justify-content: space-between;

      div.date-information {
        display: flex;
        position: relative;
        bottom: 5px;

        div.date-number {
          font-size: 25px;
          font-weight: 500;
          color: #ff6b00;
        }

        div.date-day {
          font-weight: 500;
          color: #ff6b00;
          padding-top: 10px;
        }
      }
      div.total-lecture {
        display: flex;

        div.title {
          font-weight: $font-weight500;
          padding-top: 2px;

          span {
            // color: $primary-color;
          }
        }
        div.button {
          img {
            vertical-align: middle;
            margin-left: 22px;
          }
        }
      }
    }
    ul.lecture-list {
      width: 100%;
      margin: 0;
      padding: 0 0 110px 0;
      list-style: none;

      li {
        display: flex;
        justify-content: flex-end;
        padding: 16px 0;

        div.lecture-title {
          flex: 1;
          max-width: calc(100% - 60px);

          div.word_comma_1.active {
            color: $primary-color;
          }

          div.keyword-info {
            display: flex;
            justify-content: flex-start;

            font-size: $font-base12;
            color: #fd7e2d;
          }

          div.lecture-view {
            display: flex;
            justify-content: flex-start;

            font-size: $font-base12;
            color: $font-third-color;

            div.time {
              img {
                margin-right: 3px;
              }
            }
            div.count {
              margin-left: 10px;
              img {
                margin-right: 3px;
              }
            }
          }
        }
        div.play-button {
          width: 36px;
          text-align: center;
        }
        div.menu-button {
          width: 24px;
          text-align: right;
        }
      }
    }
  }
}
div.player-div {
  padding: 0 24px;

  div.player-basic {
    margin-top: 50px;

    div.time {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      font-size: $font-base12;
      color: #1e212f;

      div.total-time {
        color: $font-third-color;
      }
    }

    div.button-group {
      clear: both;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
